module.exports = __webpack_public_path__ + "static/media/funds.aeb2028d.png";